// extracted by mini-css-extract-plugin
export default {"modal":"DownloadModal_modal__arDzs","formRow":"DownloadModal_formRow__wXkzP","smallBlurb":"DownloadModal_smallBlurb__sMxIH","errorBox":"DownloadModal_errorBox__X0KxV"};